import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black, Blue3} from "../../theme/styles";
import part_004_put_employee_request_1 from '../../json/part/part-004-put-employee-request-1.json';
import part_004_put_group_request_1 from '../../json/part/part-004-put-group-request-1.json';
import part_002_put_group_response_1 from '../../json/part/part-002-put-group-response-1.json';
import part_002_put_employee_response_1 from '../../json/part/part-002-put-employee-response-1.json';

import ReactJson from 'react-json-view'
import {Accordion, AccordionDetails, AccordionSummary, Avatar, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";

export default function PartsPut() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Parts PUT</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                In Enlil, the Parts PUT API allows for the update of part content.
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-AccessToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-AccessToken is obtained during the authentication process and expires after 90 days.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-RefreshToken (Optional String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-RefreshToken is obtained during the authentication process and never expires. This token is provided is the caller wants a refreshed X-Enlil-AccessToken</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-request (Required String: must equal v1.Part-004)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The name of the IDOC being specified in the PUT request.</li>
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>idoc-response (Optional String).</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>v1.Part-001, v1.Part-002, v1.Part-003, and v1.Part-004 are permitted values.</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>If idoc-response is provided, the response payload (HTTP Code: 201) will match the specified format, else no response (HTTP Code: 204) will be provided.</li>
                </li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Scenarios</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                <Accordion style={{backgroundColor: "#EEEEEE"}}>
                    <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1-content" id="panel1-header">
                        <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 25, height: 25, fontSize: "14px", marginRight: "10px"}}>1</Avatar>
                        <Typography style={{paddingTop: "3px"}}><b>Adding a group to a Part</b></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p style={{marginLeft: "20px"}}>
                            <span style={{lineHeight: "1.5em"}}>A group may be added to a Part through the use of the /t3/v1/parts PUT API. The following payload may be used to perform the upsert operation.</span>
                        </p>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={part_004_put_group_request_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <li style={{marginTop: "20px", marginLeft: "20px"}}>The following is a representative response.</li>
                        <br/>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={part_002_put_group_response_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <br/>
                    </AccordionDetails>
                </Accordion>
                <Accordion style={{backgroundColor: "#EEEEEE"}}>
                    <AccordionSummary expandIcon={<ExpandMore/>} aria-controls="panel1-content" id="panel1-header">
                        <Avatar sx={{marginTop: "2px", bgcolor: Blue3, width: 25, height: 25, fontSize: "14px", marginRight: "10px"}}>2</Avatar>
                        <Typography style={{paddingTop: "3px"}}><b>Adding an employee to a Part</b></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <p style={{marginLeft: "20px"}}>
                            <span style={{lineHeight: "1.5em"}}>An employee may be added to a Part through the use of the /t3/v1/parts PUT API. The following payload may be used to perform the upsert operation.</span>
                        </p>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={part_004_put_employee_request_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <li style={{marginTop: "20px", marginLeft: "20px"}}>The following is a representative response.</li>
                        <br/>
                        <p style={{fontFamily: "Courier New", fontSize: "12px", marginLeft: "20px"}}>
                            <ReactJson src={part_002_put_employee_response_1} collapseStringsAfterLength={75} collapsed={4}/>
                        </p>
                        <br/>
                    </AccordionDetails>
                </Accordion>
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Business Rules</p>
            <p style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                    <li style={{marginTop: "20px"}}>External users may not modify the ENLIL_FORM_INPUT field."
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Error Code: CC-BXDC-NXUD</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: External users may not modify the ENLIL_FORM_INPUT field.</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
                    </li>
                    <li style={{marginTop: "20px"}}>External users may not modify the PRE_CALC field."
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Error Code: CC-EGDE-MDJE</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: External users may not modify the PRE_CALC field.</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
                    </li>
                    <li style={{marginTop: "20px"}}>Schema validation error."
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Error Code: CC-JJDU-HHDE</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid value for PartRevisionUSID</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
                    </li>
                    <li style={{marginTop: "20px"}}>Invalid value for PartToBeManufactured."
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Error Code: CC-MDJE-XVCX</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid value for PartToBeManufactured</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
                    </li>

                    <li style={{marginTop: "20px"}}>Cannot transition Part to IN_REVIEW until the required number of approvers are added."
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Error Code: CC-ODOO-PP90</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Cannot transition Part to IN_REVIEW until the required number of approvers are added.</li>
                        <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
                    </li>

                </ul>
            </p>
        </div>
    )
}